/**
 * Зависимости
 */
import Mortgage from '../../components/mortgage';

/**
 * Калькулятор ипотеки
 * @type {Element}
 */
const mortgageSelector = document.querySelector('.j-mortgage');

if (mortgageSelector) {
    const mortgage = new Mortgage();

    mortgage.init(mortgageSelector);
}
